
import { defineComponent, ref, onMounted, onBeforeMount } from 'vue';
import HeaderComp from '@/components/global/Header.vue';
import UnderMaintenanceV2 from '@/components/global/UnderMaintenanceV2.vue';
// eslint-disable-next-line
import { getApi } from '@/utils/ApiCalls';
// eslint-disable-next-line
import router from '../router';

export default defineComponent({
  name: 'Solidify',
  components: { HeaderComp, UnderMaintenanceV2 },
  setup() {
    const currentRouteName = ref(router.currentRoute.name);
    const showMenuIcon = ref(false);
    const showMaintenanceWindow = ref(false);
    const maintenanceMsg = ref('');
    const isAccessTokenAvailable = ref(false);
    onMounted(async () => {
      console.log('currentRouteName}', { currentRouteName: currentRouteName.value });
      if (currentRouteName.value?.includes('Administration')) showMenuIcon.value = true;
      console.log(`showMenuIcon ${showMenuIcon.value}`);
    });
    onBeforeMount(async () => {
      try {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) isAccessTokenAvailable.value = true;
        const res = await getApi('/system/undermaintenance');
        const { data } = res;
        if (res) {
          if (data.system_under_maintainence) {
            console.log('inside learner under manitenance');
            localStorage.setItem('errorMsg', data.maintenance_message);
            showMenuIcon.value = false;
            showMaintenanceWindow.value = true;
            maintenanceMsg.value = data.maintenance_message;
            // router.push({ path: '/solidify/systemUnderMaintenance' });
          } else {
            showMaintenanceWindow.value = false;
          }
        }
      } catch (error) {
        console.log('something went wrong');
      }
    });
    return { showMenuIcon, showMaintenanceWindow, maintenanceMsg, isAccessTokenAvailable };
  },
});
